import {Component} from '@angular/core';
import {Router} from "@angular/router";

@Component({
    selector: 'serverError',
    templateUrl: './server-error.component.html',
    standalone: false
})
export class ServerErrorComponent {
  constructor(private router: Router) {}

  navigateToDashboard() {
    this.router.navigate(['login']);
  }
}
